import { Component } from '@angular/core';
import { ProjectsOverviewComponent } from './projects-overview/projects-overview.component';
import { ProjectsRoadmapComponent } from './projects-roadmap/projects-roadmap.component';
import { AllProjectsComponent } from './all-projects/all-projects.component';
import { ProjectsProgressComponent } from './projects-progress/projects-progress.component';
import { WorkingScheduleComponent } from './working-schedule/working-schedule.component';
import { ProjectsAnalysisComponent } from './projects-analysis/projects-analysis.component';
import { ToDoListComponent } from './to-do-list/to-do-list.component';
import { TeamMembersComponent } from './team-members/team-members.component';
import { RouterLink } from '@angular/router';
import {GlobalViewComponent} from "../global-view/global-view/global-view.component";
import {SampleChartComponent} from "../charts/sample-chart/sample-chart.component";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {OrderTravailComponent} from "../charts/order-travail/order-travail.component";
import {ClientChartComponent} from "../charts/client-chart/client-chart.component";
import {RapportChartComponent} from "../charts/rapport-chart/rapport-chart.component";

@Component({
    selector: 'app-project-management',
    standalone: true,
    imports: [ProjectsOverviewComponent, ProjectsRoadmapComponent, AllProjectsComponent, ProjectsProgressComponent, WorkingScheduleComponent, ProjectsAnalysisComponent, ToDoListComponent, TeamMembersComponent, RouterLink, GlobalViewComponent, SampleChartComponent, MatCard, MatCardTitle, MatCardContent, MatCardHeader, OrderTravailComponent, ClientChartComponent, RapportChartComponent],
    templateUrl: './project-management.component.html',
    styleUrl: './project-management.component.scss'
})
export class ProjectManagementComponent {}
